import { graphql } from "~/gql";

export const BEDROCK_SUGGEST_PRACTICE_AREAS_QUERY = graphql(/* GraphQL */ `
  query BedrockSuggestPracticeAreas($matterTitle: String!, $practiceAreaName: String) {
    bedrockSuggestPracticeAreas(matterTitle: $matterTitle, practiceAreaName: $practiceAreaName) {
      organisationalUnits {
        id
        name
        parent {
          id
        }
      }
    }
  }
`);
